import type { ReactNode } from 'react';

export interface SummaryDetailField {
    label: string;
    value: ReactNode;
    testId?: string;
    fullWidth?: boolean;
}

interface Props {
    fields: SummaryDetailField[];
    emptyMessage: string;
}

const isPresent = (value: ReactNode): boolean => value !== null && value !== undefined && value !== '';

export function SummaryDetailList({ fields, emptyMessage }: Props) {
    const present = fields.filter((field) => isPresent(field.value));

    if (present.length === 0) {
        return <p className="text-sm text-mp-muted">{emptyMessage}</p>;
    }

    return (
        <dl className="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
            {present.map((field) => (
                <div key={field.label} className={field.fullWidth ? 'sm:col-span-2' : undefined}>
                    <dt className="text-xs font-medium uppercase tracking-wide text-mp-muted">
                        {field.label}
                    </dt>
                    <dd className="text-sm text-mp-foreground" data-testid={field.testId}>
                        {field.value}
                    </dd>
                </div>
            ))}
        </dl>
    );
}
